import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { applyTheme, getPreferredTheme, toggleTheme } from "@/lib/theme";

export default function ThemeToggle({ className = "" }) {
  const [theme, setTheme] = useState(() =>
    typeof document !== "undefined" ? getPreferredTheme() : "dark",
  );

  useEffect(() => {
    setTheme(applyTheme(getPreferredTheme()));
  }, []);

  const onToggle = () => {
    setTheme(toggleTheme());
  };

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-lg border border-[var(--line)] bg-[var(--inset)] text-[var(--fg)] transition-transform duration-150 hover:-translate-y-px ${className}`}
      title={isDark ? "Switch to light theme" : "Switch to dark theme"}
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      data-testid="theme-toggle"
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
